export default __webpack_public_path__ + "static/media/shoes4.c713fef0.jpeg";